const React = require('react');

const BrokerDisclaimer = () => {
    return (
        <iframe></iframe>
    );
};

BrokerDisclaimer.propTypes = {
}

module.exports = BrokerDisclaimer;
